export default __webpack_public_path__ + "static/media/Mocca.ba8a93e5.png";